import { render, staticRenderFns } from "./SmartPtomData.vue?vue&type=template&id=56f9b97a&scoped=true"
import script from "./SmartPtomData.vue?vue&type=script&lang=js"
export * from "./SmartPtomData.vue?vue&type=script&lang=js"
import style0 from "./SmartPtomData.vue?vue&type=style&index=0&id=56f9b97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f9b97a",
  null
  
)

export default component.exports